export const generateStyle = (index: number, col: number): string | number => {
  if (col === 2) {
    switch (index % col) {
      case 1: {
        // return index > 1 ? 197 : 0
        return index > 1 ? '30%' : '0%'
      }
      default: {
        // return 394
        return '50%'
      }
    }
  }

  switch (index % col) {
    case 1: {
      return '0%'
    }
    case 2: {
      // return 197
      return '50%'
    }
    default: {
      // return 394
      return '100%'
    }
  }
}
